import { Component, Input, OnInit } from '@angular/core';
import { SkeletonLoaderType } from './skeleton-loader-type.enum';

@Component({
  selector: 'app-skeleton-loader',
  templateUrl: './skeleton-loader.component.html',
  styleUrls: ['./skeleton-loader.component.scss'],
})
export class SkeletonLoaderComponent implements OnInit {
  @Input() lineCount: number = 1;
  @Input() loaderType: SkeletonLoaderType = SkeletonLoaderType.PROFILE;

  skeletonLoaderType = SkeletonLoaderType;
  ngOnInit(): void {}
}
